import { Box, Button, Grid, Link, Typography } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import relatorioService from "../../services/relatorioService";
import VisaoLogo from "./VisaoLogo";
import VisaoVisualizacao from "./VisaoVisualizacao";
import logo from "../../images/imagem_404.png";

const VisualizarRelatorio = (props) => {
    const { token } = useParams();
    const [relatorio, setRelatorio] = useState(null);
    const [is_printing, setIsPrinting] = useState(false);
    const [nameRelatorio, setNameRelatorio] = useState(false);
    useEffect(() => {
        if (is_printing) {
            window.print();
        }
    }, [is_printing]);

    window.onafterprint = () => {
        setIsPrinting(false);
    };
    useEffect(async () => {
        const res = relatorioService.getRelatorioVisualizacaoToken(token);
        res.then((response) => {
            setRelatorio(response);
        }).catch((e) => {
            if (typeof e !== "undefined" && e["detail"] === "Not Found") {
                setNameRelatorio({
                    nome_relatorio:
                        "Pagina não encontrada ou relatório expirado",
                });
            }
        });
    }, [token]);
    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
        >
            <Box
                marginTop="1rem"
                width="80rem"
                maxWidth="95vw"
                marginBottom="1rem"
                minHeight="40rem"
            >
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid
                        className="noPrint"
                        container
                        direction="row"
                        justifyContent="space-between"
                        item
                        xs={12}
                        style={{ paddingBottom: "1rem" }}
                    >
                        {nameRelatorio === false && (
                            <Button
                                color="secondary"
                                size="small"
                                onClick={(e) => setIsPrinting(true)}
                            >
                                Imprimir
                            </Button>
                        )}
                    </Grid>
                    <Grid
                        className="noPrint"
                        item
                        xs={12}
                        style={{ paddingBottom: "1.5rem" }}
                    >
                        {is_printing ? (
                            <></>
                        ) : (
                            <VisaoLogo
                                relatorio={relatorio || nameRelatorio}
                                is_printing={is_printing}
                                center={nameRelatorio !== false}
                            ></VisaoLogo>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        {nameRelatorio && (
                            <img
                                src={logo}
                                loading="lazy"
                                style={{
                                    width: "50%",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    display: "block",
                                }}
                            />
                        )}
                        {relatorio != null && (
                            <VisaoVisualizacao
                                relatorio={relatorio}
                                is_printing={is_printing}
                            />
                        )}
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default VisualizarRelatorio;
